// extracted by mini-css-extract-plugin
export default {"preview":"k3OQA","content":"gai8B","image":"AlhVA"};